import React from 'react';
import { Button, Badge } from 'react-bootstrap';
const ThemeItem = _ref => {
  let {
    project_theme,
    handleDelete,
    pageAccess
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Badge, {
    pill: true,
    className: "text-dark",
    bg: "body"
  }, project_theme.theme.name, pageAccess.canEditProjectDetails && /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    className: "p-1 d-inline-flex ms-1",
    onClick: () => handleDelete(project_theme.id)
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 text-warning"
  }, "delete"))));
};
export default ThemeItem;